@if (event() && module()) {
	<div class="tw-w-full tw-h-30 tw-flex tw-flex-row tw-items-center tw-justify-center">
		<div
			class="tw-w-full tw-h-full tw-flex tw-flex-row tw-py-5 tw-items-center tw-items-self-center tw-justify-self-center tw-justify-center tw-bg-white tw-rounded-lg"
			[class.tw-px-5]="!isMobile()"
			[class.tw-px-2.5]="isMobile()"
		>
			<div class="tw-w-full tw-flex tw-flex-row tw-items-center tw-justify-evenly tw-overflow-x-auto">
				@for (day of baseDaysOnCalendar(); track day.day) {
					@let sessionsInDay = checkSessionsInDay(day);
					<div
						class="tw-h-[5rem] tw-w-20 tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center tw-border tw-border-solid tw-rounded-md tw-border-[rgba(0,0,0,0.05)] tw-py-2"
						[class.tw-px-9]="!isMobile()"
						[class.tw-px-4]="isMobile()"
						[class.tw-pointer-events-none]="!sessionsInDay"
						[class.tw-cursor-pointer]="sessionsInDay"
						[class.tw-max-w-[60px]]="isMobile()"
						[class.tw-mx-1]="isMobile()"
						[class.tw-mx-2]="!isMobile()"
						(click)="dateSelected(day)"
					>
						<span
							class="tw-font-['Heebo'] tw-text-sm tw-font-bold"
							[style.color]="!sessionsInDay ? '#bfbfbf' : event().styling.titleColor"
							>{{
								SUtility.setLocaleAndZoneOfDatetime(event(), eventUser(), day).toFormat("EEE")
									| uppercase
							}}</span
						>
						<span
							class="tw-font-['Heebo'] tw-text-xl tw-font-bold"
							[style.color]="!sessionsInDay ? '#bfbfbf' : event().styling.titleColor"
							>{{ SUtility.setLocaleAndZoneOfDatetime(event(), eventUser(), day).toFormat("dd") }}</span
						>
						<span
							class="tw-font-['Heebo'] tw-text-sm tw-font-bold"
							[style.color]="!sessionsInDay ? '#bfbfbf' : event().styling.titleColor"
							>{{
								SUtility.setLocaleAndZoneOfDatetime(event(), eventUser(), day).toFormat("MMM")
									| uppercase
							}}</span
						>

						@if (checkIsSelectedDate(day)) {
							<div
								class="tw-w-[70%] tw-h-[3px] tw-absolute tw-bottom-0 tw-rounded-[3px]"
								[style.background-color]="event().styling.btnBgColor"
							></div>
						}
					</div>
				}
			</div>

			<div
				class="tw-h-[5rem] tw-w-20 tw-flex tw-flex-col tw-items-center tw-justify-center tw-border tw-rounded-md tw-border-[rgba(0,0,0,0.05)] tw-py-2 tw-cursor-pointer"
				[class.tw-px-9]="!isMobile()"
				[class.tw-px-4]="isMobile()"
				(click)="picker.open()"
			>
				<span class="material-icons tw-w-6 tw-h-6 tw-text-[24px]" [style.color]="event().styling.titleColor"
					>calendar_month</span
				>
				<input
					class="tw-w-0 tw-h-0 tw-invisible"
					matInput
					[matDatepicker]="picker"
					[matDatepickerFilter]="checkSessionsInDay"
					[min]="minDatePicker()"
					[max]="maxDatePicker()"
					[formControl]="pickerDateFormControl()"
				/>
				<mat-datepicker [touchUi]="isMobile()" #picker>
					<mat-datepicker-actions>
						<button
							class="btn-validate"
							[style.background]="event().styling.btnBgColor"
							[style.color]="event().styling.btnTextColor"
							matDatepickerApply
							(click)="dateSelected(null)"
						>
							{{ "labels.reset" | translate }}
						</button>
						<button
							class="btn-validate tw-ml-1"
							[style.background]="event().styling.btnBgColor"
							[style.color]="event().styling.btnTextColor"
							matDatepickerApply
						>
							{{ "buttons.apply" | translate }}
						</button>
					</mat-datepicker-actions>
				</mat-datepicker>
			</div>
		</div>
	</div>
}

<!-- <div *ngIf="event" class="calendar-global-container">
	<div class="go-next-month" [style.background-color]="event.styling.btnBgColor" (click)="goNext()">
		<i
			class="arrow right"
			[style.padding]="isMobile ? '4px !important' : '5px !important'"
			[style.border-color]="event.styling.btnTextColor"
		></i>
	</div>
	<div class="go-prev-month" [style.background-color]="event.styling.btnBgColor" (click)="goPrev()">
		<i
			class="arrow left"
			[style.padding]="isMobile ? '4px !important' : '5px !important'"
			[style.border-color]="event.styling.btnTextColor"
		></i>
	</div>

	<div class="close-open-button" (click)="viewType = viewType === 'week' ? 'month' : 'week'">
		<i *ngIf="viewType === 'week'" class="arrow down" [style.border-color]="event.styling.btnBgColor"></i>
		<i *ngIf="viewType === 'month'" class="arrow up" [style.border-color]="event.styling.btnBgColor"></i>
	</div>

	<div class="calendar-month-container" [style.color]="event.styling.btnBgColor">
		<div
			class="month-text-container"
			[style.padding-left]="isMobile ? 'calc(0%)' : 'calc(50% - 50px)'"
			[style.flex-direction]="'row'"
			[style.align-items]="isMobile ? 'center' : 'space-between'"
		>
			<span>{{ getCurrentMonth() | titlecase }} {{ getCurrentYear() }}</span>

			<div class="range-dates-container">
				<span
					style="
						font-size: small;
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: flex-start;
						cursor: pointer;
					"
					(click)="getSelectedStartDate() ? (timeStartModalOpen = true) : ''"
				>
					<div
						*ngIf="getSelectedStartDate()"
						class="time-button"
						[style.background-color]="event.styling.btnBgColor"
						[style.color]="event.styling.btnTextColor"
					>
						{{ getSelectedDateTime(selectedStartDate.isoDate) }}
					</div>
				</span>
				<span
					*ngIf="getSelectedEndDate()"
					style="
						font-size: small;
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: flex-start;
						margin-top: 2px;
						cursor: pointer;
					"
					(click)="getSelectedEndDate() ? (timeEndModalOpen = true) : ''"
				>
					{{ ("labels.end" | translate) + ": " }}
					<div
						*ngIf="getSelectedEndDate()"
						class="time-button"
						[style.background-color]="event.styling.btnBgColor"
						[style.color]="event.styling.btnTextColor"
					>
						{{ getSelectedEndDate() ? getSelectedDateTime(selectedEndDate.isoDate) : "" }}
					</div>
				</span>
			</div>
		</div>
	</div>

	<div class="close-container">
		<div class="calendar-days-names-container">
			<div class="calendar-day-name" [style.color]="event.styling.titleColor" *ngFor="let day of stringDays">
				{{ day | titlecase }}
			</div>
		</div>

		<div class="calendar-days-container">
			<ng-container *ngIf="viewType === 'month'">
				<div
					class="calendar-days-week-container"
					*ngFor="let week of getWeeksOnDates(currentDateTime().month, currentDateTime().year)"
				>
					<div class="calendar-day-container" *ngFor="let day of week.days">
						<div
							class="calendar-day"
							[style.color]="
								checkSelectedDate(day) ? event.styling.btnTextColor : event.styling.titleColor
							"
							[style.background-color]="
								checkSelectedDate(day) ? event.styling.titleColor : event.styling.btnTextColor
							"
							[style.border-color]="
								checkSelectedDate(day)
									? event.styling.titleColor
									: checkCurrentDate(day)
									? event.styling.titleColor
									: 'transparent'
							"
							[style.opacity]="day.isInCurrentMonth ? 1 : 0.4"
							(click)="selectedDateOnCalendar(day)"
						>
							{{ day.dayNumber }}
							@if (currentVisibleDateOnList && checkSameVisibleDate(day)) {
							<i class="arrow right current-visible-date" [style.border-color]="'red'"></i>
							}
							<div
								*ngIf="day.totalDatas > 0"
								class="day-badge-total-datas"
								[style.background-color]="'red'"
								[style.color]="'white'"
							>
								{{ day.totalDatas }}
							</div>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="viewType === 'week'">
				<div class="calendar-days-week-container">
					<div class="calendar-day-container" *ngFor="let day of getWeeksOnDatesByWeek()">
						<div
							class="calendar-day"
							[style.color]="
								checkSelectedDate(day) ? event.styling.btnTextColor : event.styling.titleColor
							"
							[style.background-color]="
								checkSelectedDate(day) ? event.styling.titleColor : event.styling.btnTextColor
							"
							[style.border-color]="
								checkSelectedDate(day)
									? event.styling.titleColor
									: checkCurrentDate(day)
									? event.styling.titleColor
									: 'transparent'
							"
							[style.opacity]="day.isInCurrentMonth ? 1 : 0.4"
							(click)="selectedDateOnCalendar(day)"
						>
							{{ day.dayNumber }}
							@if (currentVisibleDateOnList && checkSameVisibleDate(day)) {
							<i class="arrow right current-visible-date" [style.border-color]="'red'"></i>
							}
							<div
								*ngIf="day.totalDatas > 0"
								class="day-badge-total-datas"
								[style.background-color]="'red'"
								[style.color]="'white'"
							>
								{{ day.totalDatas }}
							</div>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</div>

<ion-popover
	*ngIf="selectedStartDate"
	[isOpen]="timeStartModalOpen"
	(ionPopoverDidDismiss)="timeStartModalOpen = false; timeOfSelectedDatesUpdated()"
>
	<ng-template>
		<ion-content>
			<ion-datetime
				presentation="time"
				presentation="time"
				mode="md"
				[(ngModel)]="selectedStartDate.isoDate"
			></ion-datetime>
			<div
				style="
					width: 100%;
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;
					margin-top: 20px;
				"
			>
				<ion-button
					class="basic-button"
					style="max-width: 70px; width: 30%; box-shadow: none"
					(click)="timeStartModalOpen = false"
				>
					{{ "buttons.ok" | translate }}
				</ion-button>
			</div>
		</ion-content>
	</ng-template>
</ion-popover>

<ion-popover
	*ngIf="selectedEndDate"
	[isOpen]="timeEndModalOpen"
	(ionPopoverDidDismiss)="timeEndModalOpen = false; timeOfSelectedDatesUpdated()"
>
	<ng-template>
		<ion-content>
			<ion-datetime presentation="time" mode="md" [(ngModel)]="selectedEndDate.isoDate"></ion-datetime>
			<div
				style="
					width: 100%;
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;
					margin-top: 20px;
				"
			>
				<ion-button
					class="basic-button"
					style="max-width: 70px; width: 30%; box-shadow: none"
					(click)="timeEndModalOpen = false"
				>
					{{ "buttons.ok" | translate }}
				</ion-button>
			</div>
		</ion-content>
	</ng-template>
</ion-popover> -->
